<ng-template #content let-modal>
  <div trapFocus style="overflow-y: auto">
    <div class="modal-header ml-auto align-items-center">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="environmentForm" (ngSubmit)="onSubmit()">
      <div class="modal-body p-3 validate-lb" id="lightbox">
        <div class="row">
          <div class="col-12">
            <div class="h2-eq" style="text-align: center"></div>
            <div class="form-group mx-5 my-3">
              <input
                type="text"
                class="form-control"
                id="txtEnvironmentName"
                formControlName="environmentName"
                [placeholder]="texts?.nameTestEnvironment"
                required
                maxlength="50"
                [class.is-invalid]="
                  (environmentName.dirty || environmentName.touched) &&
                  environmentName.invalid &&
                  environmentName.errors.required
                "
                [ngStyle]="{ 'border-color': rgbColor }"
              />
            </div>

            <div class="my-3 center">
              {{ texts?.nameTestEnvironmentText1 }}
            </div>
            <div class="my-3 center">
              {{ texts?.nameTestEnvironmentText2 }}
            </div>
            <div class="my-3 center">
              {{ texts?.nameTestEnvironmentText3 }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal-footer text-uppercase"
        style="display: flex; align-items: center; justify-content: center"
      >
        <button
          class="btn font-btn-small text-uppercase btn-primary ml-2 my-2"
          [disabled]="!environmentForm.valid"
          [ngClass]="cssColor + '-inv'"
          type="submit"
        >
          {{ texts?.confirm }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
